import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (payload) => {
    const { data } = await api.post("/auth/login", payload);
    if (data.access_token) localStorage.setItem("pulb_token", data.access_token);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.access_token) localStorage.setItem("pulb_token", data.access_token);
    setUser(data);
    return data;
  };

  const verifyOtp = async (payload) => {
    const { data } = await api.post("/auth/otp/verify", payload);
    if (data.access_token) localStorage.setItem("pulb_token", data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Server logout is best-effort; local session is always cleared below.
      // eslint-disable-next-line no-console
      console.warn("Server logout failed (clearing local session anyway):", err?.message || err);
    }
    localStorage.removeItem("pulb_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, verifyOtp, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
